export const LINKS = {
  CAPACITOR_DEEPLINK_HOSTNAME: "app-dev.safeex.cloud",
  SPA_MANAGER_URL: "https://app-manager-dev.safeex.cloud",
  SPA_TECHNICIAN_URL: "https://app-dev.safeex.cloud",
  CSI_URL: "https://ws-dev.safeex.cloud",
  SPRINGBOARD_URL: "https://dev.safeex.cloud",
  USER_MANAGEMENT_URL: "https://user-admin-dev.safeex.cloud",
  MESSAGE_URL: "https://msg-dev.safeex.cloud",
} as const
